import React from 'react';
import { Tooltip } from 'antd';
import { StatusTag } from '../../common';

const IMAGE_STATUS = {
    pending: { tone: 'warning', label: 'Pendiente' },
    processing: { tone: 'info', label: 'Procesando' },
    queued: { tone: 'info', label: 'En cola' },
    completed: { tone: 'success', label: 'Completo' },
    failed: { tone: 'danger', label: 'Error' },
};

const PRODUCT_STATUS = {
    complete: { tone: 'success', label: 'Completo' },
    pending_enrichment: { tone: 'warning', label: 'Pendiente' },
};

const REVIEW_STATUS = {
    unreviewed: { tone: 'warning', label: 'Pendiente' },
    approved: { tone: 'success', label: 'Aprobado' },
    needs_fix: { tone: 'violet', label: 'Requiere ajuste' },
    rejected: { tone: 'danger', label: 'Rechazado' },
};

export default function AuditStatusBadge({ type = 'image', status, error }) {
    const map = type === 'product' ? PRODUCT_STATUS : type === 'review' ? REVIEW_STATUS : IMAGE_STATUS;
    const cfg = map[status] || { tone: 'neutral', label: status || '—' };

    return (
        <Tooltip title={error || undefined}>
            <span className="inline-flex">
                <StatusTag tone={cfg.tone} dot>
                    {cfg.label}
                </StatusTag>
            </span>
        </Tooltip>
    );
}
